import { injectable } from 'inversify'

/**
 * Wraps window.matchMedia (invariant 8: all browser APIs behind a gateway).
 *
 * Two features read the environment through it — the shell picks its starting
 * sidebar state from the viewport width, the theme resolves 'system' against
 * the OS colour scheme. Both used to call matchMedia directly, which meant
 * their tests had to stub a browser global and the jsdom setup carried a
 * matchMedia polyfill purely to stop them throwing.
 */
@injectable()
export class ViewportGateway {
  matches(query: string): boolean {
    return window.matchMedia(query).matches
  }

  /** Subscribes to changes for a query. Returns an unsubscribe function. */
  onChange(query: string, handler: (matches: boolean) => void): () => void {
    const mediaQuery = window.matchMedia(query)
    const listener = (event: MediaQueryListEvent) => handler(event.matches)

    mediaQuery.addEventListener('change', listener)
    return () => mediaQuery.removeEventListener('change', listener)
  }
}
